import { downloadCSV } from 'react-admin';
// @ts-ignore
import jsonExport from 'jsonexport/dist';

export const createAdminExporter = (filename: string, headersMap: { [key: string]: (record: any) => any }) => {
    return (records: any[]) => {
        const cleanRecords = records.map(record => {
            const mapped: any = {};
            for (const [header, mapper] of Object.entries(headersMap)) {
                try {
                    mapped[header] = mapper(record);
                } catch (e) {
                    mapped[header] = '';
                }
            }
            return mapped;
        });
        jsonExport(cleanRecords, {
            headers: Object.keys(headersMap)
        }, (err, csv) => {
            if (csv) {
                downloadCSV(csv, filename);
            }
        });
    };
};

// Exporter para Usuarios
export const userExporter = createAdminExporter('Usuarios', {
    'Nombre': record => record.name || '',
    'Apellido': record => record.lastname || '',
    'Nro Fiscal': record => record.nrofiscal || '',
    'Email': record => record.mail || '',
    'Email Usuario': record => record.usermail || '',
    'Teléfono': record => record.phone || '',
    'Rol': record => record.rol?.name || '',
    'Activo': record => record.active ? 'Sí' : 'No'
});

// Exporter para Roles
export const roleExporter = createAdminExporter('Roles', {
    'Nombre': record => record.name || '',
    'Descripción': record => record.description || '',
    'Activo': record => record.active ? 'Sí' : 'No'
});

// Exporter para Centros de Costo (Localización)
export const localizationExporter = createAdminExporter('Centros_De_Costo', {
    'Código': record => record.code || '',
    'Nombre': record => record.name || '',
    'Responsable': record => record.userInfo?.id || '',
    'Cadena Normativa': record => record.normativeChain || '',
    'Teléfono': record => record.phone || '',
    'Activo': record => record.active ? 'Sí' : 'No'
});

// Exporter para Normativas
export const normativeExporter = createAdminExporter('Normativas', {
    'Código': record => record.code || '',
    'Nombre': record => record.name || '',
    'Activo': record => record.active ? 'Sí' : 'No',
    'Operativo': record => record.operative ? 'Sí' : 'No'
});

// Exporter para Laboratorios
export const laboratoryExporter = createAdminExporter('Laboratorios', {
    'Nombre': record => record.name || '',
    'Tipo': record => record.type || '',
    'Activo': record => record.active ? 'Sí' : 'No'
});

// Exporter para Instrumentos
import periods from '../../modules/dcore/backoffice/instrument/data/periods';
export const instrumentExporter = createAdminExporter('Instrumentos', {
    'Nombre': record => record.name || '',
    'Código': record => record.code || '',
    'Marca': record => record.brand || '',
    'Modelo': record => record.model || '',
    'Periodo Calibración': record => periods.find(p => p.id === String(record.calibration?.calibrationPeriod))?.name || '',
    'Fecha Calibración': record => record.calibration?.date ? new Date(record.calibration.date).toLocaleDateString() : '',
    'Centro Costo IDs': record => record.costCenterId ? record.costCenterId.join(', ') : '',
    'Activo': record => record.active ? 'Sí' : 'No'
});

// Exporter para Exportadores
export const exporterExporter = createAdminExporter('Exportadores', {
    'Nombre': record => record.name || '',
    'Nro Fiscal': record => record.taxpayerReference || '',
    'Email': record => record.contactEmail || '',
    'Teléfono': record => record.contactPhone || '',
    'Contacto AHK': record => record.ahkContactId || '',
    'Activo': record => record.active ? 'Sí' : 'No'
});

// Exporter para Aduanas
export const customsHouseExporter = createAdminExporter('Aduanas', {
    'Nombre': record => record.name || '',
    'Contacto': record => record.contactName || '',
    'Teléfono': record => record.contactPhone || '',
    'Email': record => record.contactEmail || '',
    'Contacto AHK': record => record.ahkContactId || '',
    'Dirección': record => record.address?.street || '',
    'Activo': record => record.active ? 'Sí' : 'No'
});

// Exporter para Ubicaciones de Muestreo
export const samplingLocationExporter = createAdminExporter('Ubicaciones_De_Muestreo', {
    'Nombre': record => record.name || '',
    'Activo': record => record.active ? 'Sí' : 'No'
});

// Exporter para Reporte de Pesaje
export const weightReportExporter = createAdminExporter('Reportes_De_Pesaje', {
    'Lista Verificación': record => record.verificationList || '',
    'Aduana': record => record.operationRegistry?.customHouse?.name || '',
    'Fecha Recepción': record => record.operationRegistry?.testingLabReceptionDate ? new Date(record.operationRegistry.testingLabReceptionDate).toLocaleDateString() : '',
    'Exportador': record => record.operationRegistry?.exporter?.name || ''
});

// Exporter para Registro de Laboratorio
export const laboratoryRegistryExporter = createAdminExporter('Registros_De_Laboratorio', {
    'Nombre OI': record => record.oi?.name || '',
    'Nro Reporte Calidad': record => record.qualityReport?.number || '',
    'Aduana': record => record.operationRegistry?.customHouse?.name || '',
    'Fecha Recepción': record => record.operationRegistry?.testingLabReceptionDate ? new Date(record.operationRegistry.testingLabReceptionDate).toLocaleDateString() : '',
    'Exportador': record => record.operationRegistry?.exporter?.name || ''
});

// Exporter para Puertos
export const portExporter = createAdminExporter('Puertos', {
    'Código': record => record.code || '',
    'Nombre': record => record.name || '',
    'Activo': record => record.active ? 'Sí' : 'No'
});
